import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
  }

  *:focus {
  outline: 0;
  outline: none;
  }

  html {
    font-size: 62.5%;
    box-sizing: border-box;
    scroll-behavior: smooth;
    background-color: #4D4D4D;
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active  {
    box-shadow: 0 0 0 30px #3c3c3c inset !important;
    -webkit-box-shadow: 0 0 0 30px #3c3c3c inset !important;
    }
    input,
    textarea,
    [contenteditable] {
      caret-color: #FFFFFF !important;
    }
  }

  body {
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    line-height: 1.6;
  }

  body::-webkit-scrollbar {
    width: 1em;
  }
 
  body::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
 
  body::-webkit-scrollbar-thumb {
    background-color: #4e584c;
    outline: 1px solid #3c3c3c;
  }

  a, button {
    cursor: pointer;
  }

  a, input, textarea, button {
    outline: none;
    text-decoration: none;
    font-family: inherit;
  }

  /* Overrides */
  .MuiInput-underline:after {
    border-bottom: none;
  }

`;
